import React from "react"
import { Link } from "gatsby"
import { RichText, Date } from "prismic-reactjs"
import styled from "@emotion/styled"
import PropTypes from "prop-types"

const ProjectCardContainer = styled(Link)`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;

  transition: all 150ms ease-in-out;

  text-decoration: none;
  color: currentColor;
  background-color: #f9f9f9;
`

const ProjectCardContent = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  overflow: hidden;
  background: white;
  padding-top: 16px;

  h6 {
    width: 100%;
    text-transform: uppercase;
  }

  p,
  span {
    width: 100%;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }
`

const ProjectCardImageContainer = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 80%;
  margin: 10% 0;
  max-height: 400px;
  overflow: hidden;
  position: relative;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`

const ProjectCard = ({
  title,
  thumbnail,
  uid,
  date,
  material,
  width,
  height,
}) => {
  // transform date format
  const newDate = Date(date)
  const formattedDate = Intl.DateTimeFormat("de-DE", {
    year: "numeric",
  }).format(newDate)

  return (
    <ProjectCardContainer to={`/work/${uid}`} className="imageWrapper">
      <ProjectCardContent className="ProjectCardContent">
        <h6>
          {title[0].text}, {formattedDate}
        </h6>
        {RichText.render(material)}
        <span>
          {width} x {height} CM
        </span>
      </ProjectCardContent>
      <ProjectCardImageContainer>
        {thumbnail && <img src={thumbnail + "&w=768"} alt={title[0].text} />}
      </ProjectCardImageContainer>
    </ProjectCardContainer>
  )
}

export default ProjectCard

ProjectCard.propTypes = {
  title: PropTypes.array.isRequired,
}
